<template>
  <NotFound />
</template>

<script setup lang="ts">
import NotFound from "@/components/NotFound.vue";
import { useMeta } from "vue-meta";

useMeta({ title: "ไม่พบหน้าเพจ" });
</script>
